// This project has no tsconfig.json, so this reference is needed to pull in
// react-app-env.d.ts's ambient declarations (react-scripts types, *.css
// wildcard module) — an unimported .d.ts otherwise isn't part of this file's
// inferred TS project.
/// <reference path="../../../../../react-app-env.d.ts" />
import React, { useState, useEffect } from 'react';
import { useRestaurant } from '../../contexts/RestaurantContext.tsx';
import { ChevronDown, ChevronUp } from 'lucide-react';
import '../../styles/room-size-settings.css';
import { PIXELS_PER_METER } from '../../constants.ts';

interface RoomSizeSettingsProps {
  isCollapsed?: boolean;
  onToggle?: () => void;
}

const RoomSizeSettings: React.FC<RoomSizeSettingsProps> = ({ isCollapsed = false, onToggle }) => {
  const { floors, currentFloor, updateFloor } = useRestaurant();
  const currentFloorData = floors.find((f) => f.id === currentFloor);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (currentFloorData) {
      setWidth(currentFloorData.width / PIXELS_PER_METER);
      setHeight(currentFloorData.height / PIXELS_PER_METER);
    }
  }, [currentFloorData]);

  if (!currentFloorData) return null;

  return (
    <div className={`room-size-settings ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="selector-header" onClick={onToggle}>
        <h3>Tamanho do Ambiente</h3>
        <button className="toggle-btn">
          {isCollapsed ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
        </button>
      </div>
      {!isCollapsed && (
        <div className="settings-content">
          <div className="form-group">
            <label htmlFor="room-width">Largura (m)</label>
            <input
              id="room-width"
              type="number"
              value={width}
              onChange={(e) => {
                const val = parseFloat(e.target.value);
                setWidth(val);
                updateFloor(currentFloor, { width: val * PIXELS_PER_METER });
              }}
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="room-height">Altura (m)</label>
            <input
              id="room-height"
              type="number"
              value={height}
              onChange={(e) => {
                const val = parseFloat(e.target.value);
                setHeight(val);
                updateFloor(currentFloor, { height: val * PIXELS_PER_METER });
              }}
              className="form-control"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RoomSizeSettings;
